// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32MPq","col":"styles_col__196Dy"};